import { Icon, getSvgIcon } from '@helpers/icons';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import { rgba } from 'polished';
import * as React from 'react';
import S from './GroupLink.styles';
const GroupLink = React.forwardRef((props, ref) => {
    const hasChildren = props.item.children && props.item.children.length > 0;
    return (React.createElement(S.Container, { ref: ref, ...(hasChildren
            ? {
                as: 'button',
                onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('clicked');
                    props.onClick();
                },
            }
            : {
                href: props.item.url,
                target: props.item.target,
            }), "data-active": props.active, style: {
            '--bgHover': props.colours.bgHover,
            '--borderColour': props.colours.borderColour,
            '--iconBgColour': props.colours.iconBgColour,
            '--iconFgColour': props.colours.iconFgColour,
        } },
        React.createElement(S.GroupIcon, null, props.item.icon.icon && getSvgIcon(props.item.icon.icon)),
        props.item.label,
        hasChildren && getSvgIcon(Icon.Chevron)));
});
GroupLink.displayName = 'GroupLink';
export const GroupLinkBlock = (props) => {
    return (React.createElement(S.GroupLinkBlock, { style: {
            '--bgHover': props.colours.bgHover,
            '--iconBgColour': props.colours.iconBgColour,
            '--iconFgColour': props.colours.iconFgColour,
        } },
        React.createElement(S.GroupIcon, null, props.item.icon.icon && getSvgIcon(props.item.icon.icon)),
        React.createElement(S.GroupLinkContent, null,
            React.createElement("span", null,
                React.createElement(S.GroupLinkTitle, null, props.item.label),
                props.item.description && (React.createElement(S.GroupLinkDescription, { dangerouslySetInnerHTML: { __html: props.item.description } }))),
            React.createElement(LinkButton, { buttonType: "text", href: props.item.url, target: props.item.target, icon: Icon.Chevron }, props.item.text))));
};
export function useGetGroupColourVars(item) {
    const colours = React.useMemo(() => item.children?.map((child) => ({
        bgHover: `linear-gradient(${child.backgroundDirection === 'horizontal' ? '90deg' : '180deg'}, ${child.backgroundOpacity && child.backgroundOpacity < 1
            ? rgba(child.backgroundStart, child.backgroundOpacity)
            : child.backgroundStart} 0%, ${child.backgroundOpacity && child.backgroundOpacity < 1
            ? rgba(child.backgroundStop, child.backgroundOpacity)
            : child.backgroundStop} 100%)`,
        borderColour: child.backgroundStop,
        iconBgColour: `linear-gradient(${child.icon.backgroundDirection === 'horizontal' ? '90deg' : '180deg'}, ${child.icon.backgroundOpacity && child.icon.backgroundOpacity < 1
            ? rgba(child.icon.backgroundStart, child.icon.backgroundOpacity)
            : child.icon.backgroundStart} 0%, ${child.icon.backgroundOpacity && child.icon.backgroundOpacity < 1
            ? rgba(child.icon.backgroundStop, child.icon.backgroundOpacity)
            : child.icon.backgroundStop} 100%)`,
        iconFgColour: child.icon.textColor,
    })), [item]);
    return colours;
}
export default GroupLink;
